import { render, staticRenderFns } from "./CardBySide3.vue?vue&type=template&id=30c8e813&scoped=true&"
import script from "./CardBySide3.vue?vue&type=script&lang=js&"
export * from "./CardBySide3.vue?vue&type=script&lang=js&"
import style0 from "./CardBySide3.vue?vue&type=style&index=0&id=30c8e813&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c8e813",
  null
  
)

export default component.exports